import { render, staticRenderFns } from "./PrescriptionBuilder.vue?vue&type=template&id=4833b65b&scoped=true"
import script from "./PrescriptionBuilder.vue?vue&type=script&lang=js"
export * from "./PrescriptionBuilder.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionBuilder.vue?vue&type=style&index=0&id=4833b65b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4833b65b",
  null
  
)

export default component.exports